import { ApiKey } from 'entities/ApiKeys/types';
import { format, formatDistanceToNow } from 'date-fns';
import i18next from 'i18next';
import { IconButton } from 'shared/ui/IconButton';
import { Column } from 'shared/ui/tables/_common/types';
import { ColorPalette } from 'shared/consts/colorPalette';
import { TableTranslationLabel } from 'shared/ui/tables/_common/ui/TableTranslationLabel';

type ApiKeyRow = ApiKey & {
	onDelete: (key: ApiKey) => void;
};

const formatLastUsed = (date: string | null): string => {
	if (!date) return i18next.t('public_api_keys.never_used');
	return formatDistanceToNow(new Date(date), { addSuffix: true });
};

const formatCreated = (date: string): string => {
	return format(new Date(date), 'MMM dd, yyyy');
};

export const ApiKeysColumns: Array<Column<ApiKeyRow>> = [
	{
		field: 'name',
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="name" />,
		},
		bodyCellSettings: {
			prepareField: (row) => row?.name ?? '-',
		},
	},
	{
		field: 'keyPrefix',
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="key" />,
		},
		bodyCellSettings: {
			renderCell: (row) => (
				<span style={{ fontFamily: 'monospace', fontSize: '13px' }}>{row?.keyPrefix}****</span>
			),
		},
	},
	{
		field: 'lastUsedAt',
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="last_used" />,
		},
		bodyCellSettings: {
			renderCell: (row) => <>{formatLastUsed(row?.lastUsedAt ?? null)}</>,
		},
	},
	{
		field: 'updatedAt',
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="created" />,
		},
		bodyCellSettings: {
			renderCell: (row) => <>{row?.updatedAt ? formatCreated(row.updatedAt) : '-'}</>,
		},
	},
	{
		field: 'options',
		commonCellSettings: {
			style: { width: '80px' },
			align: 'center',
		},
		bodyCellSettings: {
			renderCell: (row) =>
				row?._id ? (
					<IconButton
						iconId={'trash'}
						sxWrapper={{ backgroundColor: ColorPalette.violetRed }}
						sxIcon={{ color: ColorPalette.white }}
						onClick={() => row?.onDelete(row)}
					/>
				) : null,
		},
	},
];
